import React from "react";
import styled from "styled-components";
import { marketingSectionHeading } from "../../styles/marketingSectionTypography";
import { device } from "../../lib/breakpoints";
import MarketingLeoDemoChat from "./MarketingLeoDemoChat";

export default function AddressHook() {
  return (
    <Section id="address-hook">
      <Shell>
        <SpanTitle>
          <DemoSectionTitle>Try it now</DemoSectionTitle>
          <DemoSectionLead>
            Type below. Leo answers like a real tenant chat. No login.
          </DemoSectionLead>
        </SpanTitle>

        <DemoWrap id="leo-demo-chat" tabIndex={-1}>
          <MarketingLeoDemoChat showDemoCaption={false} />
        </DemoWrap>

        <DemoDisclaimer>
          Live AI demo · messages are not sent to a real portfolio · capped at 5
          per session. This reflects the tenant-side Magic Link experience on the
          full LandlordOps OS. Powered by LandlordOps.
        </DemoDisclaimer>
      </Shell>
    </Section>
  );
}

const Section = styled.section`
  background: linear-gradient(180deg, #040804 0%, #060c06 100%);
  padding: 5rem 1.5rem;
  @media ${device.mobile} {
    padding: 3.5rem 1.25rem;
  }
`;

const Shell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  max-width: 640px;
  margin: 0 auto;
`;

const SpanTitle = styled.div`
  text-align: center;
  width: 100%;
`;

const DemoWrap = styled.div`
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
  /* Scroll targets (hero CTA, navbar) land on the chat frame, not the section title */
  scroll-margin-top: 5.5rem;

  /* Give the wrap itself a phone-like outer frame */
  background: linear-gradient(
    120deg,
    rgba(44, 95, 45, 0.08) 0%,
    rgba(255, 255, 255, 0.12) 100%
  );
  border-radius: 36px;
  padding: 0.75rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45), 0 4px 20px rgba(44, 95, 45, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.08);

  @media ${device.mobile} {
    scroll-margin-top: 4.75rem;
    max-width: 340px;
    padding: 0.6rem;
  }

  &:focus {
    outline: none;
  }
`;

const DemoSectionTitle = styled.h2`
  ${marketingSectionHeading}
  color: #f0fdf4;
  margin: 0 0 0.75rem 0;
`;

const DemoSectionLead = styled.p`
  font-size: clamp(1.15rem, 3.2vw, 1.35rem);
  line-height: 1.45;
  color: rgba(240, 253, 244, 0.78);
  margin: 0;
  font-family: var(--font-secondary, sans-serif);
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
`;

const DemoDisclaimer = styled.p`
  margin: 0;
  font-size: 0.7rem;
  line-height: 1.5;
  color: rgba(240, 253, 244, 0.38);
  font-family: var(--font-secondary, sans-serif);
  text-align: center;
  max-width: 340px;
`;
